const theme = {
  color: {
    //컬러는 따로 수정해야됨
    background: '#000000',
    signature: '#cea46f',
    white: '#ffffff',
  },
  size: {
    smallMobile: 'screen and (max-width: 380px)',
    mobileColumn: 'screen and (max-width: 480px)',
    mobileRow: 'screen and (max-width: 767px)',
    tablet: 'screen and (max-width: 1023px)',
    desktop: 'screen and (min-width: 1024px)',
    desktopAndTablet: 'screen and (min-width: 768px)',
    tabletAndMobile: 'screen and (max-width: 1023px)',
  },
};

export default theme;
